const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export default {
  allUsers: () => `${apiBaseUrl}/users`,
  user: (id: string) => `${apiBaseUrl}/users/${id}`,
  users: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/users/?page=${page}&pageSize=${pageSize}`,
  allProjects: () => `${apiBaseUrl}/projects`,
  project: (id: string) => `${apiBaseUrl}/projects/${id}`,
  projects: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,
  avatars: () => `${apiBaseUrl}/avatars`,
  allProducts: () => `${apiBaseUrl}/products`,
  product: (id: string) => `${apiBaseUrl}/products/${id}`,
  login: () => `${apiBaseUrl}/auth/login`,
  me: () => `${apiBaseUrl}/auth/me`,
  allProductVersions: (productId: string | number) => `${apiBaseUrl}/product-versions/${productId}`,
  createProductVersion: () => `${apiBaseUrl}/product-versions`,
  updateProductVersionStatus: (id: string | number) => `${apiBaseUrl}/product-versions/${id}/status`,
  allLicenses: () => `${apiBaseUrl}/licenses`,
  createLicense: () => `${apiBaseUrl}/licenses`,
  updateLicenseStatus: (id: string | number) => `${apiBaseUrl}/licenses/${id}/status`,
  licenseActivations: (licenseId: string | number) => `${apiBaseUrl}/license-activations/${licenseId}`,
  updateLicenseActivationStatus: (id: string | number) => `${apiBaseUrl}/license-activations/${id}/status`,
  allCustomers: () => `${apiBaseUrl}/customers`,
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token')

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

const forceLogout = () => {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('user_role')
  window.location.href = '/auth/login'
}

const apiRequest = async (url: string, options: RequestInit = {}) => {
  const response = await fetch(url, options)

  if (response.status === 401) {
    forceLogout()
  }

  return response
}

export const apiGet = async (url: string) => {
  return apiRequest(url, {
    headers: getAuthHeaders(),
  })
}

export const apiPost = async (url: string, body: unknown) => {
  return apiRequest(url, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  })
}

export const apiPut = async (url: string, body: unknown) => {
  return apiRequest(url, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  })
}

export const apiDelete = async (url: string) => {
  return apiRequest(url, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  })
}
